<template>
    <div>
        <a-modal :title="title" :visible='sureVisible' :width="1200" @ok="handleOk" @cancel="handleCancel" @close="handleCancel">
            <template slot="footer">
                <a-button @click="handleCancel">关闭</a-button>
                <a-popconfirm v-if="this.isApproval == true" title="是否通过审批?" ok-text="通过" cancel-text="不通过" @confirm="() => handleAudit(2)" @cancel="() => handleAuditCancel(3)">
                    <a-button type="primary">审批</a-button>
                </a-popconfirm>
            </template>
            
            <div>
                <span class="basicTitle">基本信息</span>
                <a-row>
                    <a-col :span="12/1">
                        <p>企业名称：</p>
                        <span>{{ supper.supplierName }}</span>
                    </a-col>
                    <a-col :span="12/1">
                        <p>编码：</p>
                        <span>{{ supper.supplierCode }}</span>
                    </a-col>
                    <a-col :span="12/1">
                        <p>法定代表人:</p>
                        <span>{{ supper.legal }}</span>
                    </a-col>
                    <a-col :span="12/1">
                        <p>统一社会信用代码:</p>
                        <span>{{ supper.credit }}</span>
                    </a-col>
                    <a-col :span="12/1">
                        <p>注册资金:</p>
                        <span>{{ supper.capital }}</span>
                    </a-col>
                    <a-col :span="12/1">
                        <p>申请原因:</p>
                        <span>{{ supper.reason }}</span>
                    </a-col>
                </a-row>
            </div>
            <div>
                <span class="lisenceTitle" >证照信息</span>
                <a-table ref="table" size="middle" bordered
                    :columns="columns" :dataSource="dataSource" :components="handleDrag(columns)" 
                    :pagination="ipagination" :loading="loading" 
                    style="word-break: break-all;">
                    <span slot="action" slot-scope="text, record">
                    <a type="primary" @click="edit(record)">编辑</a>
                    <a-divider type="vertical" />
                    <a type="primary" @click="handleDelete(record)">删除</a>
                    </span>
                    <template slot="createTime" slot-scope="createTime">
                        <span>{{changetime(createTime)}}</span>
                    </template>
                    <template slot="licenseType" slot-scope="licenseType">
                        <a-tag v-if="licenseType === 0" color="green">营业执照</a-tag>
                    </template>
                    <template slot="customPic" slot-scope="text, record">
                        <a-popover placement="right" trigger="click">
                            <template slot="content">
                            <img :src="getImgUrl(record.attachment, record.imgLarge)" width="500px" />
                            </template>
                            <div style="width:52px;height:52px;" v-if="record.attachment">
                            <img v-if="record.attachment" :src="getImgUrl(record.attachment, record.imgSmall)" class="item-img" title="查看大图" style="width:100%;height:auto"/>
                            </div>
                        </a-popover>
                    </template>
                </a-table>
            </div>
        </a-modal>
    </div>
</template>
<script>
import { editApproval } from '@/api/api'
import { campListMixins } from '../mixins/campListMixins'
import { getFileAccessHttpUrl } from '@/api/manage'

export default { 
    name: 'campDetail',
    mixins: [campListMixins],
    data() {
      return { 
        title: '详情',
        sureVisible:false,
        isApproval: false,
        uuid: '',
        supper: {
            supplierName: '',
            supplierCode: '',
            ledge: '',
            businessManager: '',
            qualityManager: '',
            credit: '',
            capital: '',
            reason: '',
        },
        supplierLicences: {
            licenseType: '',
            licenseCode: '',
            expirationDate: '',
            expirationEndDate: '',
            warningDays: '',
            paperCoding: '',
            remark: '',
        },
        columns: [
          { title: '序号', dataIndex: 'index', width: 50, customRender:(text,record,index) =>`${index + 1}`},
          { title: '证照类型', dataIndex: 'licenseType',width: 80, align: "center",scopedSlots: { customRender: 'licenseType' } },
          { title: '证照编码', dataIndex: 'licenseCode', width: 100, ellipsis: true, render: (text) => text || "--" },
          { title: '有效期起', dataIndex: 'expirationDate',width: 120, render: (text) => text || "--"},
          { title: '有效期至', dataIndex: 'expirationEndDate', width: 120, render: (text) => text || "--" },
          { title: '纸质文件编码', dataIndex: 'paperCoding', width: 120 ,ellipsis: true, render: (text) => text || "--" },
          { title: '附件', dataIndex: 'attachment', width: 65, scopedSlots: { customRender: 'customPic' } },
          { title: '备注', dataIndex: 'remark', width: 120 ,ellipsis: true, render: (text) => text || "--" },
        ],
      }
    },
    mounted(){
       
    },
    methods: {
        initShow(e,num,uuid){
            console.log(e.result,'======================e===============')
            console.log(uuid,'======================uuid==============')
            this.sureVisible = true
            this.uuid = uuid
            if(num == 2 || num !== undefined){
                this.isApproval = true
                this.supper = e.result.supper
                this.dataSource = e.result.supplierLicences
            } else {
                this.isApproval = false
                this.supper = e.result.supper
                this.dataSource = e.result.supplierLicences
            }
            
        },
        handleOk(){
            this.sureVisible = false
            this.loadData()
        },
        getImgUrl (imgName, type) {
            if (imgName && imgName.split(',')) {
                type = type ? type + '/' : ''
                return getFileAccessHttpUrl('systemConfig/static/' + type + imgName.split(',')[0])
            } else {
                return ''
            }
        },
        // 审核通过
        async handleAudit(e) {
            console.log(this.uuid,'==========uuid=?===========')
            let params = {
                uuid : this.uuid,
                state: e
            }
            const res = await editApproval(params)
            if (res.code == 200 && res.success == true) {
                this.$message.success(res.message)
                this.sureVisible = false
                this.$parent.searchReset(12)
                this.loadData()
            } else {
                this.$message.error(res.message)
            }
            
        },
            // handleAuditCancel
        async handleAuditCancel(e){
            console.log(this.uuid,'==========uuid=?===========')
            let params = {
                uuid : this.uuid,
                state: e
            }
            const res = await editApproval(params)
            if (res.code == 200 && res.success == true) {
                this.$message.success(res.message)
                this.sureVisible = false
                this.loadData()
            } else {
                this.$message.error(res.message)
            }
        },
        handleCancel(){
            this.sureVisible = false
            this.loadData()
        },
        modalFormOk(){
            this.loadData()
        },
        modalFormClose(){
            this.loadData()
        }
    }
}
</script>
<style lang="less" scoped>
    /deep/.ant-col {
        display: flex;
    }
    .basicTitle {
        display: block;
        font-size: 16x;
        margin: 0 0 30px;
        padding-left: 10px;
        border-left: 4px solid #1890FF;
    }
    .lisenceTitle {
        display: block;
        font-size: 16x;
        margin: 30px 0 30px;
        padding-left: 10px;
        border-left: 4px solid #1890FF;
    }
</style>
